{
  "hero": {
    "eyebrow": "Come funziona",
    "title": "Contrattualizza impianti di energia rinnovabile e ricevi",
    "highlight": "una quota dei ricavi ricorrenti e Garanzie di Origine.",
    "subtitle": "Un processo guidato e trasparente: dall’analisi dei tuoi obiettivi all’ottenimento pluriennale di quota dei ricavi e delle Garanzie di Origine."
  },
  "stats": {
    "peakPower": "Potenza di picco",
    "expectedProduction": "Produzione attesa"
  },
  "plants": {
    "parco-terra-5mw": {
      "name": "Parco solare a terra",
      "kind": "Terreno agricolo · Lombardia",
      "fit": "Risparmio fisso per dieci anni"
    },
    "tetto-industriale-1mw": {
      "name": "Tetto industriale",
      "kind": "Terreno agricolo · Veneto",
      "fit": "Effetto diretto sull’EBITDA"
    },
    "agrivoltaico-2mw": {
      "name": "Impianto agrivoltaico",
      "kind": "Terreno agricolo · Emilia-Romagna",
      "fit": "Una storia da mettere sul profilo pubblico"
    },
    "parco-terra-merchant": {
      "name": "Parco a terra merchant",
      "kind": "Terreno agricolo · Sicilia",
      "fit": "Ricavi che seguono il prezzo dell’energia"
    },
    "portafoglio-eecs": {
      "name": "Portafoglio certificato EECS",
      "kind": "Tre impianti · Italia e Svizzera",
      "fit": "Garanzie di Origine conformi SBTi"
    }
  },
  "model": {
    "steps": [
      {
        "k": "Step 1 - il contesto",
        "t": "Raccontaci gli obiettivi della tua azienda, i consumi energetici e gli strumenti utilizzati.",
        "d": "In una fase preliminare, DEC Energy si pone l’obiettivo di comprendere i target finanziari e di sostenibilità della tua azienda, le peculiarità dei consumi energetici e gli strumenti utilizzati."
      },
      {
        "k": "step 2 · la selezione dell’impianto",
        "t": "Ti accompagniamo nella scelta dell’impianto più adatto alle tue esigenze.",
        "d": "DEC Energy ti propone una shortlist di impianti rinnovabili attivi di proprietà di produttori terzi, aventi specifiche caratteristiche tecnologiche, geografiche, di modello di vendita di energia."
      },
      {
        "k": "step 3 · l’attivazione del contratto",
        "t": "Sottoscrizione dell’accordo pluriennale e pagamento una tantum.",
        "d": "Selezionato l’impianto, ti supportiamo nella negoziazione del contratto. Solo a seguito della firma, paga in unica soluzione il corrispettivo contrattuale."
      },
      {
        "k": "step 4 · i risultati",
        "t": "Ricevi ogni anno una quota dei ricavi e le Garanzie di Origine.",
        "d": "Per l’intera durata dell’accordo, ricevi le Garanzie di Origine e una quota dei ricavi generati dall’energia prodotta e venduta dall’impianto contrattualizzato."
      }
    ],
    "cta": {
      "primary": "Scopri le soluzioni",
      "secondary": "Contattaci"
    },
    "schema": {
      "consumi": "Consumi",
      "target": "Target",
      "fotovoltaico": "Fotovoltaico",
      "eolico": "Eolico",
      "redditoVar": "Reddito variabile",
      "redditoFisso": "Reddito fisso"
    },
    "slides": {
      "goTitle": "Garanzie di Origine",
      "revenueTitle": "Ricavi commerciali"
    }
  }
}
